// fallback in-memory API for browsers that do not have Storage API support
interface IStorageMap {
  [index: string]: string;
}

export default class MemoryStorage implements Storage {
  // this property is non functional
  public length: number = 0;
  private items: IStorageMap;
  constructor() {
    this.items = {};
  }
  public setItem(key: string, value: string) {
    this.items[key] = value;
  }
  public getItem(key: string) {
    return this.items[key] || null;
  }
  public removeItem(key: string) {
    delete this.items[key];
  }
  public clear() {
    this.items = {};
  }
  // dummy function
  public key(_index: number) {
    return null;
  }
}
